import client from '../utils/axiosInstance';

export const postAnswerSessionAPI = async (surveyId, captchaToken) => {
  const response = await client.post('answer-session', {
    surveyId: Number.parseInt(surveyId),
    captchaToken,
  });
  return response;
};
